import React from 'react';

import classes from './DropInfoDisplay.css';

const dropInfoDisplay = props => (
    <div onClick={props.clicked} className={classes.DropInfoDisplay}>
    <img
        onClick={props.clicked}
        className={classes.Image}
        src={props.image}
        alt="not found"/>
    <div className={classes.TextGroup}>
        <h3 className={classes.Name}>{props.name}</h3>
        <h3 className={classes.Variant}>{props.variant}</h3>
        <div className={classes.TextGrid}>
            <p className={classes.Edition}><strong>LE {props.edition}</strong></p>
            <p className={classes.Cost}><strong>Cost: ${props.cost}</strong></p>
        </div>
        
        <p className={classes.NumberAvailable}><strong>{props.numberAvailable} Available</strong></p>
    </div>
    
</div>
)

export default dropInfoDisplay;




// WEBPACK FOOTER //
// ./src/containers/DropInfoDisplay/DropInfoDisplay.js